import { render, staticRenderFns } from "./SfColor.vue?vue&type=template&id=09ff51a9&"
import script from "./SfColor.vue?vue&type=script&lang=js&"
export * from "./SfColor.vue?vue&type=script&lang=js&"
import style0 from "./SfColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports